<template>
  <div class="full-height">
    <div class="row container-crud q-px-sm">
      <div class="fit">
        <q-card class="q-px-sm">
          <q-card-section class="q-py-xs q-mb-sm" v-if="!insideModal">
            <div v-if="name === 'btPesquisar'" class="crud-title">
              <translate>SEARCH_RECORDS</translate>
            </div>
            <div v-else-if="name === 'btNovo'" class="crud-title">
              <translate>NEW_REGISTRATION</translate>
            </div>
            <div
              v-else-if="forms[0].nmInterface.indexOf('.alterar') > 0"
              class="crud-title"
            >
              <translate>CONTRACT_CHANGE</translate>
            </div>
          </q-card-section>
          <q-card-section class="no-padding">
            <div id="q-app">
              <q-scroll-area style="height:calc(78vh - 20px)">
                <q-stepper
                  v-model="step"
                  vertical
                  animated
                  done-color="secondary"
                  active-color="secondary"
                  inactive-color="inative"
                  class="no-shadow no-padding"
                >
                  <q-step
                    :name="1"
                    :title="$gettext('CONTRACT_DATA')"
                    icon="account_box"
                    :done="step > 1"
                  >
                    <jt-dynamic-form
                      ref="dynamicFormContract"
                      :inputs="computedContractData"
                      :relacionamentos="elements[0].relacionamentos"
                      :model="elements[0].dadosForm"
                      :interface="nmInterface"
                      form-class="form dynamic"
                      @search-found="selections"
                      class="contract-data"
                    />
                    <q-stepper-navigation class="text-center">
                      <q-btn
                        @click="nextStep"
                        color="secondary"
                        :label="$gettext('NEXT')"
                        class="q-px-lg"
                      ></q-btn>
                    </q-stepper-navigation>
                  </q-step>
                  <q-step
                    :name="2"
                    :title="$gettext('CONTRACT_SERVICE')"
                    icon="local_shipping"
                    :done="step > 2"
                  >
                    <open-composition
                      :elements="elements"
                      :dadosForm="elements[0].dadosForm"
                      nmInterfaceComp="contractService.composicao"
                      name="contractServices"
                      class="contract-service"
                      :titleTeble="this.$gettext('ADDITIONAL_SERVICES')"
                      :mountedComposition="mountedContractServices"
                      @handleDadosGrid="handleDadosGridContractService"
                    />
                    <q-stepper-navigation class="text-center">
                      <q-btn
                        @click="step = 1"
                        color="blue-grey-6"
                        :label="$gettext('PREVIOUS')"
                        class="q-px-md"
                      ></q-btn>
                      <q-btn
                        @click="nextStep"
                        color="secondary"
                        :label="$gettext('NEXT')"
                        class="q-ml-md q-px-lg"
                      ></q-btn>
                    </q-stepper-navigation>
                  </q-step>
                  <q-step
                    :name="3"
                    :title="$gettext('ITEMS_WASTE')"
                    icon="local_drink"
                    :done="step > 3"
                  >
                    <open-composition
                      :elements="elements"
                      :dadosForm="elements[0].dadosForm"
                      nmInterfaceComp="contractItem.composicao"
                      name="contractItems"
                      class="contract-items"
                      :titleTeble="this.$gettext('ADDITIONAL_ITEMS_WASTE')"
                      :inputsMultiple="inputsMultipleContractItems"
                      :mountedComposition="mountedContractItems"
                      @handleDadosGrid="handleDadosGridContractItem"
                    />
                    <q-stepper-navigation class="text-center">
                      <q-btn
                        @click="step = 2"
                        color="blue-grey-6"
                        :label="$gettext('PREVIOUS')"
                        class="q-px-md"
                      ></q-btn>
                      <q-btn
                        @click="nextStep"
                        color="secondary"
                        :label="$gettext('NEXT')"
                        class="q-ml-md q-px-lg"
                      ></q-btn>
                    </q-stepper-navigation>
                  </q-step>
                  <q-step
                    :name="4"
                    :title="$gettext('CONTRACT_SUMMARY')"
                    icon="format_align_left"
                    class="q-mb-md"
                  >
                    <contract-detail v-if="formDetail" :forms="formDetail" />
                    <q-stepper-navigation class="text-center">
                      <q-btn
                        @click="step = 3"
                        color="blue-grey-6"
                        :label="$gettext('PREVIOUS')"
                        class="q-px-md"
                      ></q-btn>
                      <q-btn
                        @click="save"
                        color="info"
                        :label="$gettext('FINISH')"
                        class="q-ml-md q-px-lg"
                      ></q-btn>
                    </q-stepper-navigation>
                  </q-step>
                </q-stepper>
              </q-scroll-area>
            </div>
          </q-card-section>
        </q-card>
      </div>
    </div>
    <div
      v-if="forms[0] && forms[0].buttons.length > 0"
      class="row full-width q-col-gutter-lg justify-center q-py-md"
    >
      <div class="col-lg-2 col-md-3">
        <q-btn class="full-width" color="grey-7" @click="limparForm">
          <translate>CLEAN</translate>
        </q-btn>
      </div>
      <div
        v-for="(button, i) in forms[0].buttons"
        :key="i"
        class="col-lg-2 col-md-3"
      >
        <q-btn class="full-width" color="info" @click="actionButton(button)">
          <q-icon
            v-if="button.icon"
            :name="button.icon"
            size="18px"
            class="position-icon-filter"
          />
        </q-btn>
      </div>
    </div>
  </div>
</template>
<script>
import { Component, Vue } from 'vue-property-decorator'
import { JtCrud, JtDynamicForm } from 'jtech-webcomps'
import { repository, messageBox } from 'jtech'
import OpenComposition from './OpenComposition'
import ContractDetail from './ContractDetail'
import moment from 'moment'
const { page, pageDetail } = JtCrud

@Component({
  mixins: [pageDetail],
  name: 'contractPage',
  components: { JtDynamicForm, OpenComposition, ContractDetail, pageDetail },
  props: {
    name: String,
    label: String,
    forms: { type: Array, required: true },
    params: Object,
    parent: Object,
    insideModal: {
      required: false,
      type: Boolean,
      default: false
    }
  }
})
class ContractPage extends Vue {
  step = 1
  numberOfContractItemsForm = 1
  inputsMultipleContractItems = [
    'contractItemBilling_value',
    'contractItemBilling_quantity'
  ]

  moment = moment
  formDetail = null
  initialDadosForm = null

  get nmInterface () {
    return 'contract.pesquisar'
  }

  mounted () {
    this.elements[0].dadosForm.contractItems = []
  }

  async loadDetail () {
    if (!this.formDetail) {
      this.formDetail = await repository.resolve('contract.detalhar', {})
    }
    this.loadRelaciontDetail(
      this.elements[0].dadosForm,
      this.elements[0].relacionamentos
    )
    this.formDetail[0].dadosForm = {
      ...this.formDetail[0].dadosForm,
      ...this.elements[0].dadosForm
    }
  }

  loadRelaciontDetail (dadosForm, relacionamentos) {
    const comboBoxNames = [
      'paymentCondition',
      'readjustmentIndex',
      'tariff',
      'paymentInstrument',
      'company',
      'landfill'
    ]
    comboBoxNames.forEach((item) => {
      if (dadosForm[item]) {
        dadosForm[item + 'Detail'] = relacionamentos[item].find(
          (x) => x.value == dadosForm[item]
        ).label
      }
    })
  }

  handleDadosGridContractService (dadosGrid) {
    const tariffSelected = this.elements[0].relacionamentos.tariff.filter(
      (item) => {
        return dadosGrid.tariff == item.value
      }
    )
    dadosGrid.tariff = tariffSelected[0].label
    dadosGrid.tariffValue = tariffSelected[0].value
  }

  handleDadosGridContractItem (dadosGrid) {
    const collectionPoints = dadosGrid.collectionPoints.replace(/[\])}[{(]/g, '').split(',')
      .map(id => {
        return { collectionPoint: Number(id) }
      })

    dadosGrid.contractItemCollectionPoints = collectionPoints

    const clientGenerators2 = dadosGrid.clientGenerators.replace(/[\])}[{(]/g, '')
    dadosGrid.clientGenerators = clientGenerators2
  }

  nextStep () {
    switch (this.step) {
      case 1:
        if (this.moment(this.elements[0].dadosForm.contractBirth, 'DD/MM/YYYY').isSameOrBefore(this.moment(this.elements[0].dadosForm.contractStart, 'DD/MM/YYYY'))) {
          messageBox.warn(this.$gettext('COMPARE_DATE'))
          break
        }
        if (this.$refs.dynamicFormContract.isValidForm()) {
          this.step++
        }
        break
      case 2:
        if (this.elements[0].dadosForm.contractServices.length == 0) {
          messageBox.error(this.$gettext('REQUIRED_CONTRACT_SERVICE'))
          return
        }
        this.step++
        break
      case 3:
        if (this.elements[0].dadosForm.contractItems.length == 0) {
          messageBox.error(this.$gettext('REQUIRED_CONTRACT_ITEM'))
          return
        }
        this.loadDetail()
        this.step++
        break
    }
  }

  async save () {
    if (this.elements[0].nmInterface.indexOf('.gravar') > 0) {
      this.elements[0].dadosForm.contractItems.forEach(contractItem => {
        this.elements[0].dadosForm.contractServices.forEach(
          contractService => {
            contractService.tariff = contractService.tariffValue
            if (contractItem.serviceType === contractService.serviceType) {
              if (!contractService.contractItems) {
                contractService.contractItems = []
              }
              contractService.contractItems.push(contractItem)
            }
          }
        )
      })
      await repository.create(
        this.elements[0].nmInterface,
        this.elements[0].dadosForm
      )
      this.clearForm()
    }
  }

  clearForm () {
    this.step = 1
    this.elements[0].dadosForm = this.getInitialDadosForm()
  }

  getInitialDadosForm () {
    return { contractServices: [], available: true, contractItems: [] }
  }

  get computedContractData () {
    return this.elements[0].inputs.filter(
      ci => ci.model != 'contractServices' && ci.model != 'contractItems'
    )
  }

  async selections (data) {
    if (data.client.idField) {
      const param = { id: data.client.idField }
      const { registros } = await repository.resolveDatatableModel(
        'client.clientAddress',
        param
      )
      delete registros[0].id
      delete registros[0].idAcaoGrid

      this.elements[0].dadosForm = {
        ...this.elements[0].dadosForm,
        ...registros[0]
      }
      this.elements[0].dadosForm.address = this.createAddressDetail(this.elements[0].dadosForm)
    } else {
      this.elements[0].dadosForm.address = null
      this.elements[0].dadosForm.phone = null
      this.elements[0].dadosForm.alternativePhone = null
      this.elements[0].dadosForm.email = null
    }
  }

  createAddressDetail ({ address, zipCode, city, state }) {
    address = address ? `${address} -` : ''
    zipCode = zipCode ? `CEP: ${zipCode} -` : ''
    city = city ? `${city} -` : ''
    state = state ? `${state}` : ''
    return `${address} ${zipCode} ${city} ${state}`
  }

  mountedContractItems (contractItems) {
    this.handleServiceTypeRelacionation(contractItems)
    contractItems.formComposition[0].inputs = contractItems.formComposition[0].inputs.filter(
      x => x.type != 'COMPOSICAO'
    )
  }

  handleServiceTypeRelacionation (contractItems) {
    if (this.elements[0].dadosForm.contractServices.length == 1) {
      const serviceTypeDadosForm = this.elements[0].dadosForm.contractServices[0].serviceType
      contractItems.formComposition[0].relacionamentos.serviceType.forEach(serviceType => {
        if (serviceType.value == serviceTypeDadosForm) {
          contractItems.formComposition[0].relacionamentos.serviceType = [serviceType]
        }
      })
    }
  }

  mountedContractServices (contractServices) {
    contractServices.formComposition[0].inputs = contractServices.formComposition[0].inputs.filter(
      x => x.type != 'COMPOSICAO'
    )
  }
}
export default ContractPage
</script>
<style lang="stylus" scoped>
.contract-data{
   #scroll-area {
      height: calc(50vh - 0px)!important;
  }
}

.contract-service{
   #scroll-area {
      height: calc(16vh - 0px)!important;
  }
}

.contract-items{
   #scroll-area {
      height: calc(40vh - 0px)!important;
  }
}

@media only screen and (max-height: 924px) {
   .contract-service{
   #scroll-area {
      height: calc(18vh - 0px)!important;
      }
    }
    .contract-items{
   #scroll-area {
      height: calc(43vh - 0px)!important;
  }
}
  }

@media only screen and (max-height: 880px) {
   .contract-data{
    #scroll-area {
      height: calc(55vh - 0px)!important;
      }
    }
    .contract-service{
   #scroll-area {
      height: calc(20vh - 0px)!important;
      }
    }
    .contract-items{
   #scroll-area {
      height: calc(46vh - 0px)!important;
  }
}
  }

  @media only screen and (max-height: 798px) {
   .contract-data{
    #scroll-area {
      height: calc(60vh - 0px)!important;
      }
    }
    .contract-items{
   #scroll-area {
      height: calc(50vh - 0px)!important;
  }
}
  }

    @media only screen and (max-height: 735px) {
   .contract-data{
    #scroll-area {
      height: calc(63vh - 0px)!important;
      }
    }
    .contract-service{
   #scroll-area {
      height: calc(22vh - 0px)!important;
      }
    }
    .contract-items{
   #scroll-area {
      height: calc(55vh - 0px)!important;
  }
}
  }
</style>
